
export const getDHM = (futureDate) =>{
    let dateNow = new Date();
    if (futureDate - dateNow <= 0) {
        return {days: 0, hours: 0, minutes: 0}
    }
    let seconds = Math.floor((futureDate - (dateNow))/1000);
    let minutes = Math.floor(seconds/60);
    let hours = Math.floor(minutes/60);
    let days = Math.floor(hours/24);

    hours = hours-(days*24);
    minutes = minutes-(days*24*60)-(hours*60);
    seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);
    return {days, hours, minutes,seconds}
}